import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase-config";
import { useEffect, useState } from "react";

export default function FlowDetail() {
    const { useCaseId, flowId } = useParams();
    const [flow, setFlow] = useState(null);

    useEffect(() => {
        async function loadFlow() {
            const ref = doc(db, "useCases", useCaseId, "Flows", flowId);
            const snap = await getDoc(ref);
            if (snap.exists()) setFlow(snap.data());
        }
        loadFlow();
    }, [useCaseId, flowId]);

    if (!flow) return <p>Loading ...</p>;

    return (
        <div className="flowDetail">
            <h1>{flow.title}</h1>
            <p className="card">{flow.description}</p>

            <a href={`/useCases/${useCaseId}`} className="backLink">
                ← Back to Use Case
            </a>

            {flow.longDescription && (
                <section>
                    <h2>Overview</h2>
                    <p>{flow.longDescription}</p>
                </section>
            )}

            {flow.useCaseSteps && (
                <section className="useCaseRows">
                    <h2>Use Case Steps</h2>
                    <ol>
                        {flow.steps.map((s, i) => <li key={i}>{s}</li>)}
                    </ol>
                </section>
            )}

            {flow.flowSteps && (
                <section>
                <h2>Flow Steps</h2>
                <ul>
                    {flow.flowSteps.map((step, i) => (
                    <li key={i}>{step}</li>
                    ))}
                </ul>
                </section>
            )}

            {flow.inputs && (
                <section className="useCaseRows">
                    <h2>Inputs</h2>
                    <ul>
                        {flow.inputs.map((i, idx) => <li key={idx}>{i}</li>)}
                    </ul>
                </section>
            )}

            {flow.outputs && (
                <section className="useCaseRows">
                    <h2>Outputs</h2>
                    <ul>
                        {flow.outputs.map((o, idx) => <li key={idx}>{o}</li>)}
                    </ul>
                </section>
            )}

            {flow.images && (
                <section>
                <h2>Images</h2>
                {flow.images.map((img, i) => (
                    <figure key={i}>
                    <img src={img.url} alt={img.label} className="flowImage" />
                    <figcaption>{img.label}</figcaption>
                    </figure>
                ))}
                </section>
            )}
        </div>
    );
}